"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _bar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/bar.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _bar.default);
var BAR_TYPES = process.env.NODE_ENV !== "production" ? ['default', 'header', 'subheader', 'header-with-subheader', 'footer', 'floating-footer'] : {};
/** The **Bar** component is a container that holds titles, buttons and input
 * controls. Its contents are distributed into three areas: left, middle and
 * right. This component’s primary function is to display page **headers** and
 * **footers**. It is mainly used to construct a **Page**, and acts as a
 * building block for other components like **Dialog**, **Popover** etc.
 *
 * @returns {Node} Bar component
 */

function Bar(_ref) {
  var _context, _classnames;

  var className = _ref.className,
      cozy = _ref.cozy,
      cssNamespace = _ref.cssNamespace,
      leftComponents = _ref.leftComponents,
      middleComponents = _ref.middleComponents,
      rightComponents = _ref.rightComponents,
      type = _ref.type,
      props = (0, _objectWithoutProperties2.default)(_ref, ["className", "cozy", "cssNamespace", "leftComponents", "middleComponents", "rightComponents", "type"]);
  var Tag;

  switch (type) {
    case 'header':
    case 'header-with-subheader':
      Tag = 'header';
      break;

    case 'footer':
    case 'floating-footer':
      Tag = 'footer';
      break;

    default:
      Tag = 'div';
  }

  var barClasses = classnames("".concat(cssNamespace, "-bar"), (_classnames = {}, (0, _defineProperty2.default)(_classnames, (0, _concat.default)(_context = "".concat(cssNamespace, "-bar--")).call(_context, type), type !== 'default'), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-bar--cozy"), cozy), _classnames), className);
  var elementClasses = classnames("".concat(cssNamespace, "-bar__element"));
  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({
    className: barClasses
  }, props), leftComponents && /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(cssNamespace, "-bar__left"))
  }, (0, _map.default)(leftComponents).call(leftComponents, function (child, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: elementClasses,
      key: index
    }, child);
  })), middleComponents && /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(cssNamespace, "-bar__middle"))
  }, (0, _map.default)(middleComponents).call(middleComponents, function (child, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: elementClasses,
      key: index
    }, child);
  })), rightComponents && /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(cssNamespace, "-bar__right"))
  }, (0, _map.default)(rightComponents).call(rightComponents, function (child, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: elementClasses,
      key: index
    }, child);
  })));
}

process.env.NODE_ENV !== "production" ? Bar.propTypes = {
  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to enable cozy mode */
  cozy: _propTypes.default.bool,

  /** Node(s) to render within the component */
  leftComponents: _propTypes.default.node,

  /** Node(s) to render within the component */
  middleComponents: _propTypes.default.node,

  /** Node(s) to render within the component */
  rightComponents: _propTypes.default.node,

  /** Bar type */
  type: _propTypes.default.oneOf(BAR_TYPES)
} : void 0;
Bar.defaultProps = {
  cozy: false,
  type: 'default'
};

var _default = (0, _withStyles.default)(Bar);

exports.default = _default;